module.exports = __webpack_public_path__ + "static/media/logo-cms.7b2e136f.png";